import { sitekey } from 'constants/turnstile';
import { FC, useEffect } from 'react';
import { css } from '@emotion/css';
import { Flex } from 'antd';
import asyncLoadScript from 'utils/asyncLoadScript';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    onloadTurnstileCallback: () => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    turnstile: any;
  }
}
let id: string;

const Turnstile: FC<{ onSuccess?: (token: string) => void }> = ({ onSuccess }) => {
  useEffect(() => {
    // @ts-ignore
    if (window?.onloadTurnstileCallback) {
      return;
    }
    window.onloadTurnstileCallback = function() {
      if (id) {
        return;
      }
      id = window.turnstile.render('.cf-turnstile', {
        sitekey,
        language: 'en-US',
        callback: function(token: string) {
          onSuccess?.(token);
        },
      });
    };
    asyncLoadScript('https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback', false);
  }, [onSuccess]);
  return (
    <Flex vertical align="center" justify="center" className={cssTurnstile} gap={60}>
      <Flex vertical gap={32} align="center" justify="center">
        <div className={cssTitle}>{"Verify that it's you"}</div>
        <div>
          To help keep your account safe, <br />
          Verify that it is you trying to log in
        </div>
      </Flex>
      <Flex vertical gap={20} align="center" justify="center">
        <div>{"I'm not a robot"}</div>
        <div className="cf-turnstile"></div>
      </Flex>
    </Flex>
  );
};

export default Turnstile;

const cssTurnstile = css`
  height: calc(100vh - 64px);
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
`;

const cssTitle = css`
  font-size: 40px;
  font-weight: 600;
  line-height: 40px;
`;
